import {
    Alert,
    Box,
    Chip,
    Collapse,
    Container,
    Grid,
    IconButton,
    InputBase,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Pagination,
    Paper,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/styles';
import SubCard from 'ui-component/cards/SubCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import ViewInoicePreorder from './ViewInoicePreorder';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import { StyledMenu, StyledMenuItem } from 'ui-component/MenuPopup';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloseIcon from '@mui/icons-material/Close';
import SetReject from './controller/SetReject';
import SetComing from './controller/SetComing';
import CompleteOrder from './controller/CompleteOrder';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import StockMapingOrder from './StockMapingOrder';
import CategoryIcon from '@mui/icons-material/Category';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import ViewInoice from 'views/invoice/ViewInoice';
import DescriptionIcon from '@mui/icons-material/Description';
import QrCode2Icon from '@mui/icons-material/QrCode2';
export const PreorderInvoiceManage = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleCloseMore = () => {
        setAnchorEl(null);
    };
    const [openBackdrop, setopenBackdrop] = useState(false);
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });
    const theme = useTheme();
    const [BillData, setBillData] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [page, setpage] = useState(1);
    const [total, settotal] = useState(0);
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [ValueSearch, setValueSearch] = useState('');
    const [OpenInvoicePreorder, setOpenInvoicePreorder] = useState(false);
    const [OpenReject, setOpenReject] = useState(false);
    const [OpenComing, setOpenComing] = useState(false);
    const [OpenComplete, setOpenComplete] = useState(false);
    const [SelectedData, setSelectedData] = useState({});
    const [anchorElStatus, setAnchorElStatus] = useState(null);
    const [selectedIndex, setSelectedIndex] = React.useState(4);
    const [SelectStatus, setSelectStatus] = useState('^');
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [DataInvoice, setDataInvoice] = useState({});
    const PreviewInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/aonewallet/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                setDataInvoice(Preview.data?.data);
                setOpenInvoice(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    const handleCloseStatus = (event, index) => {
        setSelectedIndex(index);
        setAnchorElStatus(null);
        // console.log(event.target.id);

        if (event.target.id !== '' && event.target.id !== undefined) {
            setpage(1);
            setSelectStatus(event.target.id);
        }
    };
    const handleClickStatus = (event) => {
        setAnchorElStatus(event.currentTarget);
    };

    const handlePage = (event, value) => {
        setpage(value);
    };
    const columns = [
        // { field: '_id', headerName: 'id', width: 90 },
        {
            field: 'status',
            headerName: 'Status',
            width: 130,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                // <Typography
                //     color={
                //         params.row.status === '0'
                //             ? 'red'
                //             : params.row.status === '1'
                //             ? 'primary'
                //             : params.row.status === '2'
                //             ? 'green'
                //             : 'silver'
                //     }
                //     variant="button"
                //     gutterBottom
                //     style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                // >
                //     {params.row.status === '0'
                //         ? 'Order'
                //         : params.row.status === '1'
                //         ? 'Coming'
                //         : params.row.status === '2'
                //         ? 'Completed'
                //         : 'Reject'}
                // </Typography>
                <Chip
                    variant="outlined"
                    color={
                        params.row.status === '0'
                            ? 'error'
                            : params.row.status === '1'
                                ? 'info'
                                : params.row.status === '2'
                                    ? 'success'
                                    : 'default'
                    }
                    icon={
                        params.row.status === '0' ? (
                            <AssignmentReturnedIcon />
                        ) : params.row.status === '1' ? (
                            <QrCode2Icon />
                        ) : params.row.status === '2' ? (
                            <CheckCircleOutlineIcon />
                        ) : params.row.status === 'pending' ? (
                            <HourglassBottomIcon />
                        ) : (
                            <ThumbDownIcon />
                        )
                    }
                    label={
                        params.row.status === '0'
                            ? 'Order'
                            : params.row.status === '1'
                                ? 'QR Payment'
                                : params.row.status === '2'
                                    ? 'Completed'
                                    : params.row.status === 'pending'
                                        ? 'Pending'
                                        : 'Reject'
                    }
                />
            )
        },
        ,
        {
            field: 'invoiceRequest',
            headerName: 'Invoice Preorder',
            width: 200,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.invoiceRequest}
                </Typography>
            )
        },
        // {
        //     field: 'paymentType',
        //     headerName: 'PaymentType',
        //     width: 120,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
        //             {params.row.paymentType}
        //         </Typography>
        //     )
        // },
        {
            field: 'totalPayment',
            headerName: 'Total',
            width: 100,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography variant="body1" color="#f57224" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={params.row.totalPayment}
                        prefix="₭"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                    />
                </Typography>
            )
        },
        {
            field: 'customer',
            headerName: 'customer',
            width: 120,
            // flex: 0.5,
            // editable: true,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Stack>
                    <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customerID}
                    </Typography>
                    <Typography variant="caption" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customers.customerName}
                    </Typography>
                </Stack>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 160,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return (
                    <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
                    </Typography>
                );
            }
        },
        {
            field: 'saleBy',
            headerName: 'SaleBy',
            width: 150,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                    {params.row.saleBy}
                </Typography>
            )
        },
        {
            field: 'action',
            headerName: 'Action',
            // flex: 0.5,
            width: 150,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                if (params.row.status !== '3' && params.row.status !== '2' && params.row.status !== '1' && params.row.status !== 'pending') {
                    return (
                        <Stack direction="row" spacing={1}>
                            <IconButton
                                // color="primary"
                                sx={{ color: '#0c4da2' }}
                                onClick={() => {
                                    setSelectedData(params.row);
                                    setOpenInvoicePreorder(true);
                                }}
                            >
                                <VisibilityIcon />
                            </IconButton>
                            <IconButton
                                size="medium"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                component="span"
                                style={{ marginLeft: 1 }}
                                onClick={(e) => {
                                    setAnchorEl(e.currentTarget);
                                    console.log(params.row);
                                    setSelectedData(params.row);
                                }}
                            >
                                {/* {params.getValue("ref")} */}
                                <MoreVertIcon />
                            </IconButton>
                            <strong>
                                <StyledMenu
                                    id="customized-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleCloseMore}
                                >
                                    {/* <StyledMenuItem
                                        onClick={() => {
                                            handleCloseMore();
                                            setOpenComing(true);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <LocalShippingIcon variant="contained" color="secondary" fontSize="default" />
                                        </ListItemIcon>
                                        <ListItemText primary="Set to Coming" />
                                    </StyledMenuItem> */}
                                    <StyledMenuItem
                                        onClick={() => {
                                            handleCloseMore();
                                            setOpenComplete(true);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <ShoppingCartIcon variant="contained" color="success" fontSize="default" />
                                        </ListItemIcon>
                                        <ListItemText primary="Complete Order" />
                                    </StyledMenuItem>
                                    <StyledMenuItem
                                        onClick={() => {
                                            handleCloseMore();
                                            setOpenReject(true);
                                        }}
                                    >
                                        <ListItemIcon>
                                            <ThumbDownIcon variant="contained" color="default" fontSize="default" />
                                        </ListItemIcon>
                                        <ListItemText primary="Reject" />
                                    </StyledMenuItem>
                                </StyledMenu>
                            </strong>
                        </Stack>
                    );
                } else if (params.row.status === '2') {
                    return (
                        <Stack direction="row" spacing={1}>
                            <IconButton
                                // color="primary"
                                sx={{ color: '#0c4da2' }}
                                onClick={() => {
                                    setSelectedData(params.row);
                                    setOpenInvoicePreorder(true);
                                }}
                            >
                                <VisibilityIcon />
                            </IconButton>
                            <IconButton
                                // color="primary"
                                sx={{ color: '#0c4da2' }}
                                onClick={() => {
                                    PreviewInvoice(params.row.invoiceRequest);
                                }}
                            >
                                <DescriptionIcon />
                            </IconButton>
                        </Stack>
                    );
                } else {
                    return (
                        <Stack direction="row" spacing={1} >
                            <IconButton
                                // color="primary"
                                sx={{ color: '#0c4da2' }}
                                onClick={() => {
                                    setSelectedData(params.row);
                                    setOpenInvoicePreorder(true);
                                }}
                            >
                                <VisibilityIcon />
                            </IconButton>
                        </Stack >
                    );
                }
            }
            // editable: true
        }
    ];
    async function LoadData(ValueFind) {
        try {
            setBillData([]);
            setopenBackdrop(true);
            const valueReplate = ValueFind === '' ? '^' : ValueFind.toLowerCase();

            const response = await axios.get(ApiLink + '/api/requestproduct/invoice/' + valueReplate + '/' + page + '/' + SelectStatus, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setBillData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    useEffect(() => {
        LoadData(ValueSearch);
    }, [page, SelectStatus]);
    return (
        <>
            <SetReject
                Open={OpenReject}
                setOpen={setOpenReject}
                ReloadData={LoadData}
                SelectedData={SelectedData}
                setAlertBox={setAlertBox}
            />
            <SetComing
                Open={OpenComing}
                setOpen={setOpenComing}
                ReloadData={LoadData}
                SelectedData={SelectedData}
                setAlertBox={setAlertBox}
            />
            <ViewInoice setOpen={setOpenInvoice} Open={OpenInvoice} DataInvoice={DataInvoice} />
            <CompleteOrder Open={OpenComplete} setOpen={setOpenComplete} ReloadData={LoadData} SelectedData={SelectedData} />
            <ViewInoicePreorder Open={OpenInvoicePreorder} setOpen={setOpenInvoicePreorder} DataInvoice={SelectedData} />
            <Collapse in={AlertBox.open}>
                <Alert
                    sx={{ padding: '10px', mb: 2 }}
                    // variant="outlined"
                    severity={AlertBox.severity}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAlertBox({ ...AlertBox, open: false });
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    {AlertBox.message}
                </Alert>
            </Collapse>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <StockMapingOrder />
                </Grid>
                <Grid item xs={12}>
                    <SubCard
                        title="Preorder List"
                        contentSX={{ p: 0 }}
                        show={true}
                        secondary={
                            <Paper style={{ display: 'flex', width: matchDownSM ? 200 : 400 }} elevation={2}>
                                <InputBase
                                    type="text"
                                    fullWidth
                                    disabled={openBackdrop}
                                    style={{
                                        marginLeft: 1,
                                        flex: 1,
                                        fontFamily: 'boonhome-400'
                                    }}
                                    value={ValueSearch}
                                    onChange={(event) => {
                                        setValueSearch(event.target.value);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.keyCode == 13) {
                                            setpage(1);
                                            LoadData(ValueSearch);
                                        }
                                    }}
                                    placeholder="Invoice Number"
                                    inputProps={{ 'aria-label': 'Invoice Number' }}
                                    endAdornment={
                                        <Stack direction="row">
                                            <IconButton
                                                disabled={openBackdrop}
                                                className="iconbutton"
                                                aria-label="search"
                                                onClick={(e) => {
                                                    setpage(1);
                                                    LoadData(ValueSearch);
                                                }}
                                            >
                                                <SearchIcon />
                                            </IconButton>
                                            <Stack direction="row-reverse">
                                                <IconButton
                                                    disabled={openBackdrop}
                                                    className="iconbutton"
                                                    aria-controls="menu-popular-card"
                                                    aria-haspopup="true"
                                                    onClick={handleClickStatus}
                                                >
                                                    <CategoryIcon
                                                        // fontSize="small"
                                                        color="primary"
                                                    />
                                                </IconButton>
                                                <Menu
                                                    id="menu-cate-card"
                                                    anchorEl={anchorElStatus}
                                                    keepMounted
                                                    open={Boolean(anchorElStatus)}
                                                    onClose={handleCloseStatus}
                                                    variant="selectedMenu"
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right'
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right'
                                                    }}
                                                    value={SelectStatus}
                                                >
                                                    <MenuItem
                                                        selected={4 === selectedIndex}
                                                        // selected={SelectCate === item.categoryID}
                                                        key={4}
                                                        onClick={(event) => handleCloseStatus(event, 4)}
                                                        value={'^'}
                                                        id={'^'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('^');
                                                            }}
                                                            id={'^'}
                                                            variant="outlined"
                                                            label={'All Status'}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        selected={0 === selectedIndex}
                                                        // selected={SelectCate === item.categoryID}
                                                        key={0}
                                                        onClick={(event) => handleCloseStatus(event, 2)}
                                                        value={'0'}
                                                        id={'0'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('0');
                                                            }}
                                                            id={'0'}
                                                            variant="outlined"
                                                            color={'error'}
                                                            icon={<AssignmentReturnedIcon />}
                                                            label={'Order'}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        selected={1 === selectedIndex}
                                                        // selected={SelectCate === item.categoryID}
                                                        key={1}
                                                        onClick={(event) => handleCloseStatus(event, 1)}
                                                        value={'1'}
                                                        id={'1'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('1');
                                                            }}
                                                            id={'1'}
                                                            variant="outlined"
                                                            color={'info'}
                                                            icon={<QrCode2Icon />}
                                                            label={'QR Payment'}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        selected={2 === selectedIndex}
                                                        // selected={SelectCate === item.categoryID}
                                                        key={2}
                                                        onClick={(event) => handleCloseStatus(event, 2)}
                                                        value={'2'}
                                                        id={'2'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('2');
                                                            }}
                                                            id={'2'}
                                                            variant="outlined"
                                                            color={'success'}
                                                            icon={<CheckCircleOutlineIcon />}
                                                            label={'Completed'}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        selected={3 === selectedIndex}
                                                        // selected={SelectCate === item.categoryID}
                                                        key={3}
                                                        onClick={(event) => handleCloseStatus(event, 3)}
                                                        value={'3'}
                                                        id={'3'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('3');
                                                            }}
                                                            id={'3'}
                                                            variant="outlined"
                                                            color={'default'}
                                                            icon={<ThumbDownIcon />}
                                                            label={'Reject'}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        selected={5 === selectedIndex}
                                                        key={5}
                                                        onClick={(event) => handleCloseStatus(event, 5)}
                                                        value={'pending'}
                                                        id={'pending'}
                                                    >
                                                        <Chip
                                                            onClick={() => {
                                                                setSelectStatus('pending');
                                                            }}
                                                            id={'pending'}
                                                            variant="outlined"
                                                            color={'default'}
                                                            icon={<HourglassBottomIcon />}
                                                            label={'Pending'}
                                                        />
                                                    </MenuItem>
                                                </Menu>
                                            </Stack>
                                        </Stack>
                                    }
                                    startAdornment={
                                        <IconButton
                                            disabled={openBackdrop}
                                            className="iconbutton"
                                            aria-label="refresh"
                                            onClick={() => {
                                                // setData(dataOriginal);
                                                setValueSearch('');
                                                LoadData('');
                                            }}
                                        >
                                            <RefreshIcon />
                                        </IconButton>
                                    }
                                />
                            </Paper>
                        }
                    >
                        <Box
                            // style={{
                            //     width: '100%',
                            //     height: '80vh',
                            //     textAlign: 'center'
                            //     // overflow: "auto",
                            // }}
                            sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}
                        >
                            <StyledDataGrid
                                loading={openBackdrop}
                                getRowId={(row) => row._id}
                                rows={BillData}
                                columns={columns}
                                // pageSize={20}
                                rowHeight={100}
                                headerHeight={60}
                                hideFooter={true}
                            />
                        </Box>

                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                paddingTop: '5px'
                            }}
                        >
                            <Pagination
                                disabled={openBackdrop}
                                count={totalPage}
                                // variant="outlined"
                                page={page}
                                size="small"
                                shape="rounded"
                                color="primary"
                                onChange={handlePage}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                        <p
                            style={{
                                fontSize: '10px',
                                display: 'flex',
                                justifyContent: 'center',
                                paddingTop: '5px'
                            }}
                        >
                            Total : {total}
                        </p>
                    </SubCard>
                </Grid>
            </Grid>
        </>
    );
};
